import { SHARE_SOURCE } from '../../../types'

/*
  The QR destination per shareable source. No row means no QR tab.
  Keep in step with the QR builder's `getCalendarSourcesConfig`.
*/
const QR_SOURCE_TYPE_BY_SHARE_SOURCE: Partial<Record<SHARE_SOURCE, string>> = {
  [SHARE_SOURCE.CALENDAR]: 'calendars',
  [SHARE_SOURCE.GROUP]: 'calendarGroups',
}

export const qrSourceTypeFor = (source?: SHARE_SOURCE | null): string | null =>
  (source && QR_SOURCE_TYPE_BY_SHARE_SOURCE[source]) || null
